import React, { useCallback, useMemo } from 'react';
import { useGenerateAlisaAudio } from '../../api';

const GenerateAudio = ({ render, onGenerateSuccess }) => {
  const options = useMemo(
    () => ({
      onSuccess: onGenerateSuccess,
    }),
    [onGenerateSuccess]
  );
  const { generateAudio, loading } = useGenerateAlisaAudio(options);

  const handleGenerateBtnClick = useCallback(
    ({ shutdownId, text }) => generateAudio({ shutdownId, text }),
    [generateAudio]
  );

  return render({
    onClick: handleGenerateBtnClick,
    loading,
  });
};

export default GenerateAudio;
